import _Number$parseInt from "@babel/runtime-corejs2/core-js/number/parse-int";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";

/* tslint:disable:no-any */
import { SessionManagerStateType } from '@central-products/interface-session-manager';
import { abortable } from '../libs/abortable';
import { SessionFoundError } from '../libs/session-found-error';
export var SessionLoginListenerNativeStrategy = /*#__PURE__*/function () {
  function SessionLoginListenerNativeStrategy(config) {
    _classCallCheck(this, SessionLoginListenerNativeStrategy);

    this.config = config;

    _defineProperty(this, "abortController", void 0);

    _defineProperty(this, "nativeLoginSubscriptionToken", void 0);
  }

  _createClass(SessionLoginListenerNativeStrategy, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.abortController = new AbortController();
                _context.next = 4;
                return _Promise.race([this.watchAbort(), this.watchLogin()]);

              case 4:
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                this.stop();

                if (_context.t0 instanceof SessionFoundError) {
                  this.config.onStateChangedCallback(SessionManagerStateType.LOGGED_IN, _context.t0.state);
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.abortController) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (!this.abortController.signal.aborted) {
                  this.abortController.abort();
                  this.abortController = undefined;
                }

                if (this.nativeLoginSubscriptionToken) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                this.config.transport.unsubscribe(this.nativeLoginSubscriptionToken);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "watchAbort",
    value: function watchAbort() {
      var _this = this;

      return new _Promise(function (_, reject) {
        var onAbortCallback = function onAbortCallback() {
          _this.abortController.signal.removeEventListener('abort', onAbortCallback);

          reject();
        };

        _this.abortController.signal.addEventListener('abort', onAbortCallback);
      });
    }
  }, {
    key: "watchLogin",
    value: function watchLogin() {
      var _this2 = this;

      return new _Promise(function (_, reject) {
        /**
         * Sportsbook native apps for UK emit `native.login` event with
         * payload of `1` (logged in) or `0` (not logged in).
         *
         * We attach to this event and when we receive `1` as payload
         * we then call CAS to perform session check.
         */
        _this2.nativeLoginSubscriptionToken = _this2.config.transport.subscribe({
          topic: 'native.login',
          callback: function () {
            var _callback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(data) {
              var response;
              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      if (!(_Number$parseInt(data, 10) !== 1)) {
                        _context5.next = 2;
                        break;
                      }

                      return _context5.abrupt("return");

                    case 2:
                      _context5.prev = 2;
                      _context5.next = 5;
                      return abortable( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                        var responseCASSynchronization;
                        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                          while (1) {
                            switch (_context3.prev = _context3.next) {
                              case 0:
                                _context3.next = 2;
                                return _this2.config.casClient.init({
                                  serviceUrl: _this2.config.serviceUrl,
                                  custLogin: true
                                });

                              case 2:
                                responseCASSynchronization = _context3.sent;

                                if (responseCASSynchronization.success) {
                                  _context3.next = 5;
                                  break;
                                }

                                throw responseCASSynchronization;

                              case 5:
                                return _context3.abrupt("return", responseCASSynchronization);

                              case 6:
                              case "end":
                                return _context3.stop();
                            }
                          }
                        }, _callee3);
                      })), {
                        signal: _this2.abortController.signal
                      });

                    case 5:
                      _context5.next = 7;
                      return abortable( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                        var responseCASImAlive;
                        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                          while (1) {
                            switch (_context4.prev = _context4.next) {
                              case 0:
                                _context4.next = 2;
                                return _this2.config.casClient.imAlive();

                              case 2:
                                responseCASImAlive = _context4.sent;

                                if (responseCASImAlive.success) {
                                  _context4.next = 5;
                                  break;
                                }

                                throw responseCASImAlive;

                              case 5:
                                return _context4.abrupt("return", responseCASImAlive);

                              case 6:
                              case "end":
                                return _context4.stop();
                            }
                          }
                        }, _callee4);
                      })), {
                        signal: _this2.abortController.signal
                      });

                    case 7:
                      response = _context5.sent;
                      reject(new SessionFoundError(response.state));
                      _context5.next = 14;
                      break;

                    case 11:
                      _context5.prev = 11;
                      _context5.t0 = _context5["catch"](2);
                      reject(_context5.t0);

                    case 14:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5, null, [[2, 11]]);
            }));

            function callback(_x) {
              return _callback.apply(this, arguments);
            }

            return callback;
          }()
        });
      });
    }
  }]);

  return SessionLoginListenerNativeStrategy;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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